module.exports = __webpack_public_path__ + "img/Z71_14.173ebd11.jpg";